export default "__VITE_ASSET__BgK_mZMJ__"